import { englishValidationMessages } from './messages';
import { getMaxLengthValidator, noHtmlPatternValidator } from './rawValidators';
import { getRequiredValidator } from './required';
export const titleMaxLength = 120;
const maxLength = titleMaxLength;
const maxLengthValidator = getMaxLengthValidator(maxLength);
export const makeTitleValidators = (messages)=>{
    /** true means there's no error. false means there's an error. string means there's an error and gives the error-message. */ function getTitleValidator() {
        let valueName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : messages.fieldNames.title, required = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        const requiredValidator = getRequiredValidator(required);
        return (value)=>{
            const requiredError = requiredValidator(value);
            if (requiredError !== true) {
                return requiredError;
            }
            if (!maxLengthValidator(value)) {
                return messages.tooLong({
                    field: valueName,
                    max: maxLength
                });
            }
            if (!noHtmlPatternValidator(value)) {
                return messages.htmlCharacters({
                    field: valueName
                });
            }
            return true;
        };
    }
    /** For react-hook-form library. */ const titleValidation = function titleValidation(valueName) {
        let { required } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return {
            validate: {
                title: getTitleValidator(valueName, required)
            },
            dataAttr: {
                'data-validation': 'title'
            }
        };
    };
    return {
        getTitleValidator,
        titleValidation
    };
};
export const { getTitleValidator, titleValidation } = makeTitleValidators(englishValidationMessages);
